import { gql } from '@apollo/client';

export const CREATE_PSA = gql`
  mutation CreatePSA($input: CreatePSAInput!) {
    createPSA(input: $input) {
      _id
      title
      description
      imageUrl
      location {
        type
        coordinates
      }
      startDate
      endDate
      language
    }
  }
`;

export const UPDATE_PSA = gql`
  mutation UpdatePSA($_id: ID!, $input: UpdatePSAInput!) {
    updatePSA(_id: $_id, input: $input) {
      _id
      title
      description
      imageUrl
      location {
        type
        coordinates
      }
      startDate
      endDate
    }
  }
`;

export const DELETE_PSA = gql`
  mutation DeletePSA($_id: ID!) {
    deletePSA(_id: $_id) {
      _id
      title
    }
  }
`;
